import { createSimpleFunctional } from '@/util'

export const VCardText = createSimpleFunctional('v-card-text')
